import * as Sentry from '@sentry/react';

import { AppSettings } from 'settings';
import { InvalidRouteIntParamError } from 'const';

export function initSentry(appConfig: AppSettings) {
  if (appConfig.sentryUri?.startsWith('http')) {
    const conf: Sentry.BrowserOptions = {
      dsn: appConfig.sentryUri,
      release: appConfig.appVersion,
      environment: appConfig.environment,
      debug: false,
      integrations: [Sentry.browserTracingIntegration()],
      beforeSend(event, hint) {
        const error = hint.originalException;

        if (error instanceof InvalidRouteIntParamError) {
          event.level = 'warning';
          event.fingerprint = ['invalid-route-param'];
        }

        return event;
      },
    };

    Sentry.init(conf);
  }
}
